// extracted by mini-css-extract-plugin
module.exports = {"botton":"Income_botton__3OaiD","title":"Income_title__31wV7","subTitle":"Income_subTitle__ISAWU","amount":"Income_amount__2mEft","eachCase":"Income_eachCase__2_MnC"};